import React, { useState, useEffect, useCallback } from 'react';
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge';
import PubSub from 'pubsub-js';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

function FilterTag(props) {
    const [filterTagList, setFilterTagList] = useState([]);
    const [filterMatchedTagList, setFilterMatchedTagList] = useState([]);
    const [loading, setLoading] = useState(props.Loading);

    const handleResponse = useCallback((response) => {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    }, []);

    const bindFilteredTag = useCallback((role, distributor_UserId, name, wholesalerid, datefrom, dateto, FilterJson) => {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'requestHeader': FilterJson },
                body: JSON.stringify({ role, distributor_UserId, name, wholesalerid, datefrom, dateto })
            };
            return fetch(`/api/Filter/getFilterMatchingTag`, requestOptions)
                .then(handleResponse)
                .then(apidata => {
                    try {             
                        setFilterTagList(JSON.parse(FilterJson));
                        setFilterMatchedTagList(apidata);
                    }
                    catch (error) {
                        try {
                            setFilterTagList(FilterJson);
                            setFilterMatchedTagList(apidata);
                        }
                        catch (error) {
                        }
                    }
                });
        }
        catch (error) {
        }
    }, [handleResponse]);

    // componentDidMount
    useEffect(() => {
        if (props.FilterTags != null && props.FilterTags != '' && props.FilterTags != undefined && props.FilterTags != "null") {
            if (props.Roletype != "Admin" && props.Roletype != "SubAdmin") {
                bindFilteredTag(props.Roletype, props.dist_id, props.Rolename, props.wh_Id, props.df, props.dt, props.FilterTags);
            }
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // componentDidUpdate
    useEffect(() => {
        if (props.FilterTags != null && props.FilterTags != '' && props.FilterTags != undefined && props.FilterTags != "null") {
            if (props.Roletype != "Admin") {
                setFilterTagList([]);
                bindFilteredTag(props.Roletype, props.dist_id, props.Rolename, props.wh_Id, props.df, props.dt, props.FilterTags);
            }
        } else {
            setFilterTagList([]);
            setFilterMatchedTagList([]);
        }
    }, [props.FilterTags, props.Roletype, props.dist_id, props.Rolename, props.wh_Id, props.df, props.dt, bindFilteredTag]);

    const handeChangefiltertag = useCallback((e) => {
        props.handeChangefiltertag(props.dashboardName, props.startDate, props.endDate);
    }, [props]);

    const handleRemoveTag = useCallback((e) => {
        try {
            var CreatedJson = '';
            const parent = e.target.closest('[data-nodename]');
            let dnodename = parent?.getAttribute('data-nodename');
            let dnodeval = parent?.getAttribute('data-nodevalue');
            
            try {
                let ExistJson = JSON.parse(localStorage.getItem('Advance_Filter'));
                CreatedJson = JSON.stringify(ExistJson);

                // If direct key lookup fails (e.g. "PharmacyChain" vs "Pharmacy Chain"),
                // fall back to a normalized key match to handle spaced variants stored from chart clicks
                if (!ExistJson[dnodename]) {
                    const matchedKey = Object.keys(ExistJson).find(k =>
                        k.replace(/\s+/g, '').toLowerCase() === dnodename.toLowerCase()
                    );
                    if (matchedKey) dnodename = matchedKey;
                }

                let ItemIndex = ExistJson[dnodename]?.indexOf(dnodeval) ?? -1;
                if (ItemIndex > -1) {
                    ExistJson[dnodename].splice(ItemIndex, 1);

                    if (ExistJson[dnodename].length == 0) {
                        delete ExistJson[dnodename]
                    }

                }
                else if (dnodename == "PhZip" || dnodename == "PrZip") {
                    let ItemIndex = ExistJson[dnodename].indexOf(dnodeval.replace('-', ''));
                    ExistJson[dnodename].splice(ItemIndex, 1);

                    if (ExistJson[dnodename].length == 0) {
                        delete ExistJson[dnodename]
                    }
                }
                try {
                    if (JSON.stringify(ExistJson) == "{}") {
                        localStorage.setItem('Advance_Filter', null);
                    }
                    else {
                        localStorage.setItem('Advance_Filter', JSON.stringify(ExistJson));
                    }
                    let newDate = new Date();
                    localStorage.setItem('Filter_Last_Update_Time', newDate);
                    localStorage.setItem('Updated_AdFilter_Status', CreatedJson + newDate);
                    
                    // Check if removing PBM: HD filter and current claim type is not totalpaid
                    const currentHDType = localStorage.getItem('Updated_HD_Type');
                    if (currentHDType && currentHDType != "totalpaid" && dnodename == "PBM" && dnodeval == "HD") {
                        var LocalHDType = localStorage.getItem('Updated_HD_Type');
                        localStorage.setItem('Prev_HD_Type', LocalHDType);
                        localStorage.setItem('Updated_HD_Type', 'totalpaid');
                        let newDate = new Date();
                        localStorage.setItem('Filter_Last_Update_Time', newDate);
                        PubSub.publish('PBM', 'HD')
                    }
                    props.handlechangea(e);
                }
                catch (error) {
                }
            }
            catch (error) {
            }
        } catch (error) {
        }
    }, [props]);

    const handleResetButton = useCallback((e) => {
        try {
            PubSub.publish('PBM', 'HD');
            // Hide all filter tags (now handled by state re-render)
            setLoading(false);
            setFilterTagList([]);
            setFilterMatchedTagList([]);
            
            var CreatedJson = '';
            let ExistJson = JSON.parse(localStorage.getItem('Advance_Filter'));
            CreatedJson = JSON.stringify(ExistJson);
            localStorage.setItem('Advance_Filter', null);
            let newDate = new Date();
            localStorage.setItem('Filter_Last_Update_Time', newDate);
            localStorage.setItem('Updated_AdFilter_Status', CreatedJson + newDate);
            
            var LocalHDType = localStorage.getItem('Updated_HD_Type');
            localStorage.setItem('Prev_HD_Type', LocalHDType);
            localStorage.setItem('Updated_HD_Type', 'totalpaid');
            let newDate1 = new Date();
            localStorage.setItem('Filter_Last_Update_Time', newDate1);
            
            props.handlechangea(e);
        }
        catch (error) {
        }
    }, [props]);

    const getTagTypeFullName = useCallback((stext) => {
        if (stext == 'PBM') {
            return 'PCN';
        }
        else if (stext == 'PhBin') {
            return 'BIN';
        }
        else if (stext == 'DistributorName') {
            return 'Distributor Name'
        }
        else if (stext == 'PhCity') {
            return 'Pharmacy City'
        }
        else if (stext == 'PrCity') {
            return 'Prescriber City'
        }
        else if (stext == 'PhState') {
            return 'Pharmacy State'
        }
        else if (stext == 'PrState') {
            return 'Prescriber State'
        }
        else if (stext == 'PhZip') {
            return 'Pharmacy ZIP'
        }
        else if (stext == 'PrZip') {
            return 'Prescriber ZIP'
        }
        else if (stext == 'PharmacyName') {
            return 'Pharmacy Name'
        }
        else if (stext == 'GroupNumber') {
            return 'Group Number'
        }
        else if (stext == 'WholesalerName') {
            return 'Wholesaler Name'
        }
        else if (stext == 'DrugName') {
            return 'Drug Name'
        }
        else if (stext == 'Prescriber') {
            return 'Prescriber Name'
        }
        else if (stext == 'PrescriberName') {
            return 'Prescriber Name'
        }
        else if (stext == 'Override') {
            return 'Override';
        }
        else if (stext == 'PhGPrefix' || stext ==="Group Prefix") {
            return 'Group Prefix';
        }
        else if (stext == 'WebCampaign') {
            return 'Web Campaign';
        }
        else if (stext == 'BrokerName') {
            return 'Broker Name';
        }
        else if (stext == 'EmailCampaign') {
            return 'Email Campaign';
        }
        else if (stext == 'Other') {
            return 'Other Name';
        }
        else if (stext == 'SMSCampaign') {
            return 'SMS Campaign';
        }
        else if (stext == 'MailCampaign') {
            return 'Mail Campaign';
        }
        else if (stext == 'Pharmacy Chain' || stext == 'PharmacyChain') {
            return 'Pharmacy Chain';
        }
        else {
            // Return the original text if no match found
            return stext || 'Unknown';
        }
    }, []);

    // Reverse mapping: Convert display names back to short codes for localStorage
    const getShortKeyName = useCallback((displayName) => {
        // Create a case-insensitive mapping
        const mapping = {
            'pcn': 'PBM',
            'bin': 'PhBin',
            'distributor name': 'DistributorName',
            'pharmacy city': 'PhCity',
            'prescriber city': 'PrCity',
            'pharmacy state': 'PhState',
            'prescriber state': 'PrState',
            'pharmacy zip': 'PhZip',
            'prescriber zip': 'PrZip',
            'pharmacy name': 'PharmacyName',
            'group number': 'GroupNumber',
            'wholesaler name': 'WholesalerName',
            'drug name': 'DrugName',
            'prescriber name': 'Prescriber',
            'override': 'Override',
            'group prefix': 'Group Prefix',
            'web campaign': 'WebCampaign',
            'broker name': 'BrokerName',
            'email campaign': 'EmailCampaign',
            'other name': 'Other',
            'sms campaign': 'SMSCampaign',
            'mail campaign': 'MailCampaign',
            'pharmacy chain': 'PharmacyChain'
        };
        
        // Normalize to lowercase for lookup
        const normalizedName = displayName?.toLowerCase().trim();
        return mapping[normalizedName] || displayName;
    }, []);

    let s2 = filterMatchedTagList;
    let icount = 0;
    Object.keys(filterTagList).map((key, index) => {
        icount = icount + 1;
    });

    const renderTag = useCallback((key, value, hasData = false) => {
        // Skip rendering if key or value is undefined/null
        if (!key || !value || value === 'undefined' || value === 'null') {
            return null;
        }
        
        // For non-admin users, if hasData is false, show grayish styling
        const isNonAdmin = props.Roletype !== "Admin" && props.Roletype !== "SubAdmin";
        const showGrayStyle = isNonAdmin && !hasData;
        
        return (
            <Badge 
                key={key + value}
                variant="outline"
                id={key.replace(' ', '') + value.replace(' ', '')} 
                className={cn(
                    "inline-flex items-center gap-1.5 px-3 py-1 rounded-md text-xs font-normal leading-none whitespace-nowrap",
                    showGrayStyle
                        ? "bg-background text-muted-foreground border-muted-foreground"
                        : "bg-primary/10 text-primary border-primary"
                )}
                data-nodename={key} 
                data-nodevalue={value}
            >
                {getTagTypeFullName(key) + ': ' + value}
                <Button
                    variant="ghost"
                    size="icon"
                    onClick={handleRemoveTag}
                    className="h-4 w-4 p-0 hover:bg-transparent hover:text-current [&_svg]:size-2.5"
                >
                    <X />
                </Button>
            </Badge>
        );
    }, [getTagTypeFullName, handleRemoveTag, props.Roletype]);

    if (icount > 0 && filterTagList != null) {
        return (
            <div className="mb-4">
                <div className="flex items-start gap-4">
                    {/* Scrollable tags container */}
                    <div className="overflow-x-auto">
                        <div className="flex items-start gap-4 min-w-min">
                    {Object.keys(filterTagList).map((key, index) => {
                        try {
                            // For each value in filterTagList[key], find its matching entry in filterMatchedTagList
                            return filterTagList[key].map((value, i1) => {
                                try {
                                    // Get short key for API matching
                                    const shortKey = getShortKeyName(key);
                                    
                                    // Normalize key for matching (handle variations like "Prescriber Name" vs "Prescriber")
                                    const normalizeKey = (k) => k.replace(/\s+/g, '').toLowerCase();
                                    
                                    // Find the specific matching filter by both tableType and value
                                    // Match by normalized key (case-insensitive, no spaces)
                                    const matchedFilter = filterMatchedTagList.find((d) => {
                                        const normalizedTableType = normalizeKey(d["tableType"]);
                                        const normalizedShortKey = normalizeKey(shortKey);
                                        const normalizedKey = normalizeKey(key);
                                        
                                        // Try exact match with short key first
                                        if (d["tableType"] === shortKey && d["value"] === value) {
                                            return true;
                                        }
                                        
                                        // Try exact match with display name
                                        if (d["tableType"] === key && d["value"] === value) {
                                            return true;
                                        }
                                        
                                        // Try normalized match with short key
                                        if (normalizedTableType === normalizedShortKey && d["value"] === value) {
                                            return true;
                                        }
                                        
                                        // Try normalized match with display name
                                        if (normalizedTableType === normalizedKey && d["value"] === value) {
                                            return true;
                                        }
                                        
                                        // Special case: "Prescriber Name"/"PrescriberName" should match "Prescriber"
                                        if ((normalizedKey === 'prescribername' && normalizedTableType === 'prescriber') ||
                                            (normalizedKey === 'prescriber' && normalizedTableType === 'prescribername') ||
                                            (normalizedShortKey === 'prescriber' && normalizedTableType === 'prescriber')) {
                                            return d["value"] === value;
                                        }
                                        
                                        return false;
                                    });
                                    
                                    // If found, use its hasData value, otherwise default to false
                                    const hasData = matchedFilter ? matchedFilter.hasData === "True" : false;
                                    
                                    return renderTag(key, value, hasData);
                                } catch (error) {
                                    return null;
                                }
                            });
                        } catch (error) {
                            return null;
                        }
                    })}
                        </div>
                    </div>
                    {/* Reset button - fixed outside scroll */}
                    {filterTagList.propertyIsEnumerable.length > 0 && s2.length > 0 && (
                        <Button 
                            variant="ghost" className="h-auto py-1 px-3 gap-1.5 whitespace-nowrap flex-shrink-0 leading-[1.15] bg-foreground text-card border border-foreground hover:bg-foreground hover:text-card hover:opacity-85"
                            onClick={handleResetButton}
                        >
                            Reset
                        </Button>
                    )}
                </div>
            </div>
        );
    }

    const LocalFilterJson = JSON.parse(localStorage.getItem('Advance_Filter'));
    if (LocalFilterJson != null && LocalFilterJson.propertyIsEnumerable.length > 0) {
        return (
            <div className="mb-4">
                <div className="flex items-start gap-4">
                    {/* Scrollable tags container */}
                    <div className="overflow-x-auto">
                        <div className="flex items-start gap-4 min-w-min">
                    {Object.keys(LocalFilterJson).map((key, index) => {
                        return LocalFilterJson[key].map((e1, i1) => {
                            return renderTag(key, e1, false);
                        });
                    })}
                        </div>
                    </div>
                    {/* Reset button - fixed outside scroll */}
                    <Button 
                        variant="ghost" className="h-auto py-1 px-3 gap-1.5 whitespace-nowrap flex-shrink-0 leading-[1.15] bg-foreground text-card border border-foreground hover:bg-foreground hover:text-card hover:opacity-85"
                        onClick={handleResetButton}
                    >
                        Reset
                    </Button>
                </div>
            </div>
        );
    }

    return <div className="mb-4"></div>;
}

export default FilterTag;
